import { Component } from '@angular/core';

import { AuthorizationService } from '../../../shared/index';

@Component({
    selector: 'pmuser-index',
    templateUrl: './pmuser-index.html',
    standalone: false
})

export class PMUserIndexComponent {
    constructor(
        private _authorizationService: AuthorizationService,
    ) { }

    //public isInRole(component: string): boolean {
    //    return this._authorizationService.hasRole(component);
    //}
}
